<template>
  <div>

    <!-- top navigation bar -->
    <div class="navbar-custom">
      <div class="container-fluid">

          <!-- LOGO -->
          <div class="logo-box">
            <router-link to="/" class="logo logo-dark text-center">
              <span class="logo-sm">
                <img src="../assets/images/logo-sm.png" alt="" height="22">
              </span>
              <span class="logo-lg">
                <img src="../assets/images/logo-dark.png" alt="" height="20">
              </span>
            </router-link>

            <router-link to="/" class="logo logo-light text-center">
              <span class="logo-sm">
                <img src="../assets/images/logo-sm.png" alt="" height="22">
              </span>
              <span class="logo-lg">
                <img src="../assets/images/logo-light.png" alt="" height="20">
              </span>
            </router-link>
          </div>

          <div class="clearfix"></div>
      </div>
    </div>
    <!-- /top navigation bar -->

    <!-- side menu -->
    <div class="left-side-menu">

      <div class="h-100" data-simplebar>

        <!--- Sidemenu -->
        <div id="sidebar-menu">

          <ul id="side-menu">
            <li>
              <a href="#" @click.prevent.stop="changeIframe('corp1', '企業一覧')">
                <i class="mdi mdi-checkbox-marked-circle-outline"></i>
                <span class="badge badge-success badge-pill float-right">CorpList1.vue</span>
                <span> 企業一覧1 </span>
              </a>
            </li>
            <li>
              <a href="#" @click.prevent.stop="changeIframe('corp2', '企業一覧')">
                <i class="mdi mdi-checkbox-marked-circle-outline"></i>
                <span class="badge badge-success badge-pill float-right">CorpList2.vue</span>
                <span> 企業一覧2 </span>
              </a>
            </li>
            <li>
              <a href="#" @click.prevent.stop="changeIframe('corp3', '企業一覧')">
                <i class="mdi mdi-checkbox-marked-circle-outline"></i>
                <span class="badge badge-success badge-pill float-right">CorpList3.vue</span>
                <span> 企業一覧3 </span>
              </a>
            </li>
            <li>
              <a href="#" @click.prevent.stop="changeIframe('corp4', '企業一覧')">
                <i class="mdi mdi-checkbox-marked-circle-outline"></i>
                <span class="badge badge-success badge-pill float-right">CorpList4.vue</span>
                <span> 企業一覧4 </span>
              </a>
            </li>
            <li>
              <a href="#" @click.prevent.stop="changeIframe('corp5', '企業一覧')">
                <i class="mdi mdi-checkbox-marked-circle-outline"></i>
                <span class="badge badge-success badge-pill float-right">CorpList5.vue</span>
                <span> 企業一覧5 </span>
              </a>
            </li>
            <li>
              <a href="#" @click.prevent.stop="changeIframe('corp6', '企業一覧')">
                <i class="mdi mdi-checkbox-marked-circle-outline"></i>
                <span class="badge badge-success badge-pill float-right">CorpList6.vue</span>
                <span> 企業一覧6 </span>
              </a>
            </li>
            <li>
              <a href="#" @click.prevent.stop="changeIframe('corp7', '企業一覧')">
                <i class="mdi mdi-checkbox-marked-circle-outline"></i>
                <span class="badge badge-success badge-pill float-right">CorpList7.vue</span>
                <span> 企業一覧7 </span>
              </a>
            </li>
            <li>
              <a href="#" @click.prevent.stop="changeIframe('corp8', '企業一覧')">
                <i class="mdi mdi-checkbox-marked-circle-outline"></i>
                <span class="badge badge-success badge-pill float-right">CorpList8.vue</span>
                <span> 企業一覧8 </span>
              </a>
            </li>
            <li>
              <a href="#" @click.prevent.stop="changeIframe('corp9', '企業一覧')">
                <i class="mdi mdi-checkbox-marked-circle-outline"></i>
                <span class="badge badge-success badge-pill float-right">CorpList9.vue</span>
                <span> 企業一覧9 </span>
              </a>
            </li>
            <li>
              <a href="#" @click.prevent.stop="changeIframe('corp10', '企業一覧')">
                <i class="mdi mdi-checkbox-marked-circle-outline"></i>
                <span class="badge badge-success badge-pill float-right">CorpList10.vue</span>
                <span> 企業一覧10 </span>
              </a>
            </li>
            <li>
              <a href="#" @click.prevent.stop="changeIframe('build1', '物件一覧')">
                <i class="mdi mdi-checkbox-marked-circle-outline"></i>
                <span class="badge badge-success badge-pill float-right">BuildList1.vue</span>
                <span> 物件一覧1 </span>
              </a>
            </li>
            <li>
              <a href="#" @click.prevent.stop="changeIframe('build2', '物件一覧')">
                <i class="mdi mdi-checkbox-marked-circle-outline"></i>
                <span class="badge badge-success badge-pill float-right">BuildList2.vue</span>
                <span> 物件一覧2 </span>
              </a>
            </li>
            <li>
              <a href="#" @click.prevent.stop="changeIframe('build3', '物件一覧')">
                <i class="mdi mdi-checkbox-marked-circle-outline"></i>
                <span class="badge badge-success badge-pill float-right">BuildList3.vue</span>
                <span> 物件一覧3 </span>
              </a>
            </li>
            <li>
              <a href="#" @click.prevent.stop="changeIframe('build1/8817', '物件詳細')">
                <i class="mdi mdi-checkbox-marked-circle-outline"></i>
                <span class="badge badge-success badge-pill float-right">BuildAritcle1.vue</span>
                <span> 物件詳細1 </span>
              </a>
            </li>

          </ul>

        </div>
        <!-- End Sidebar -->

        <div class="clearfix"></div>

      </div>
      <!-- Sidebar-left -->
    </div>
    <!-- /side menu -->

    <div class="content-page">
      <div class="content">
        <div class="embed-responsive">
          <iframe id="largeIframe" class="embed-responsive-item" :src="'#/' + view" style="height: calc(100vh - 145px);"></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      view: 'corp1'
    }
  },
  mounted() {
    if( sessionStorage.view ) {
      this.view = sessionStorage.view
    }
    // messsageを受け取った時点のコンテンツの高さをiframeの高さにする
    window.addEventListener('message', function() {
      // const sub = document.getElementById("largeIframe");
      // sub.style.height = sub.contentWindow.document.body.scrollHeight + 'px';
      // console.log('iframe height:' + sub.contentWindow.document.body.scrollHeight);
    }, false);
  },
  methods: {
    changeIframe: function(permalink) {
      this.view = permalink
      sessionStorage.view = permalink
    }
  }
}
</script>

<style lang="scss" scoped>
.content-page {
  background: #f5f6f8;
  min-height: calc(100vh - 70px);
}
.navbar-custom {
  top: 0;
}

.embed-responsive {
  overflow: visible;
}

.embed-responsive iframe,
.embed-responsive .embed-responsive-item {
  position: static;
}
</style>

<style lang="scss">
body {
  padding-bottom: 0 !important;
}
</style>